import { Button } from "@mui/material";
import type { PimoReactComponent } from "@pimo/pimo-app-builder";
import { getLocalizedMessage, type SupportedLanguage } from "@pimo/pimo-l10n";

import { StatusPageLayout } from "./status-page-layout";

export type NoAccessPageEvent = "no-access:home-portal" | "no-access:logout";

export type NoAccessPageProps = {
  language: SupportedLanguage;
};

export const NoAccessPage: PimoReactComponent<
  NoAccessPageProps,
  NoAccessPageEvent
> = ({ fireEvent, language }) => (
  <StatusPageLayout
    code="403"
    title={getLocalizedMessage(language, "noAccess.title")}
    description={getLocalizedMessage(language, "noAccess.description")}
    actions={
      <>
        <Button
          variant="contained"
          onClick={() => fireEvent?.("no-access:home-portal")}
        >
          {getLocalizedMessage(language, "noAccess.homePortal")}
        </Button>
        <Button variant="text" onClick={() => fireEvent?.("no-access:logout")}>
          {getLocalizedMessage(language, "noAccess.switchAccount")}
        </Button>
      </>
    }
  />
);
